<template>
    <div class="number-box" :title="tooltip" v-b-tooltip>
        <div class="number-label">
            {{ number }}
        </div>

        <div class="icon-container">
            <div class="icon" :class="icon + '-icon-bg'" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            number: {
                type: Number,
                required: true,
            },

            icon: {
                type: String, // seat, suitcase
                required: true,
            },

            // eslint-disable-next-line vue/require-default-prop
            tooltip: {
                type: String,
                required: false,
            },
        },
    };
</script>

<style scoped>
    .number-box {
        background-color: #4F91A3;
        width: fit-content;
        color: #ffffff;
        height: 39px;
    }

    .number-box .number-label {
        font-size: 1.4rem;
        line-height: 1.5rem;
        font-weight: bold;
        display: inline-block;
        padding-left: 8px;
        padding-right: 6px;
        vertical-align: top;
        padding-top: 9px;
    }

    .number-box .icon-container {
        background-color: rgba(0,0,0,0.2);
        display: inline-block;
        width: 32px;
        height: 38px;
    }

    .number-box .icon {
        width: 32px;
        height: 29px;
        background-position: bottom center;
    }

    .number-box .icon.suitcase-icon {
        padding-top: 8px;
    }
</style>
